import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { FullCalendarModule } from '@fullcalendar/angular';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TextMaskModule } from 'angular2-text-mask';
import { Daterangepicker } from 'ng2-daterangepicker';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ComponentModule } from '../../../components/component.module';
import { LayoutModule } from '../../../layouts/layout.module';
import { TelemedicineModule } from '../../telemedicine/telemedicine.module';
import { AccWidgetsModule } from '../accounting/acc-widgets/acc-widgets.module';
import { CovidModule } from '../covid/covid.module';
import { HomeComponent } from '../home.component';
import { TrtWidgetsModule } from '../treatment/trt-widgets/trt-widgets.module';
import {
    AccountingService,
    CommentService,
    CommonService,
    CommunicationService,
    DocumentsService,
    ResultService,
    SurveyService,
    TaskService,
    TermsService,
    VisitService,
} from '../_services';
import { CanLeaveModule } from './../../../../auth/can-leave/can-leave.module';
import { TokenInterceptor } from './../../../../token.interceptor';
import { AssetStringPipe } from './../../../../_shared/pipes/asset-string.pipe';
import { MfToastService } from './../../../../_shared/services/mfToast.service';
import { NgbDateMomentParserFormatter } from './../../../../_shared/services/NgbDateMomentParserFormatter.class';
import { MainCalAssetsComponent } from './main-cal-assets/main-cal-assets.component';
import { MainCalCustomerSearchComponent } from './main-cal-customer-search/main-cal-customer-search.component';
import { MainCalSlotPopupComponent } from './main-cal-slot-popup/main-cal-slot-popup.component';
import { MainCalSubcComponent } from './main-cal-subc/main-cal-subc.component';
import { MainCalSubsListComponent } from './main-cal-subc/main-cal-subs-list/main-cal-subs-list.component';
import { SubcGroupOrderPipe } from './main-cal-subc/main-cal-subs-list/subc-group-order.pipe';
import { MainCalViewFiltersComponent } from './main-cal-view-filters/main-cal-view-filters.component';
import { MainCalendarPopupHeaderComponent } from './main-calendar-popup-header/main-calendar-popup-header.component';
import { MainCalendarPopupComponent } from './main-calendar-popup/main-calendar-popup.component';
import { MainCalendarComponent } from './main-calendar.component';

const routes: Routes = [
    {
        path: 'main',
        component: HomeComponent,
        children: [
            {
                path: '',
                component: MainCalendarComponent,
            },
        ],
    },
];

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentModule,
        FullCalendarModule,
        NgScrollbarModule,
        TrtWidgetsModule,
        TelemedicineModule,
        CovidModule,
        NgSelectModule,
        CanLeaveModule,
        EditorModule,
        AccWidgetsModule,
        Daterangepicker,
        RouterModule.forChild(routes),
        TextMaskModule,
        NgxDatatableModule,
        OverlayModule,
    ],
    exports: [RouterModule, MainCalSubsListComponent],
    declarations: [
        MainCalendarComponent,
        MainCalViewFiltersComponent,
        MainCalAssetsComponent,
        MainCalSubcComponent,
        MainCalSubsListComponent,
        MainCalendarPopupComponent,
        MainCalendarPopupHeaderComponent,
        SubcGroupOrderPipe,
        MainCalSlotPopupComponent,
        MainCalCustomerSearchComponent,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        {
            provide: NgbDateParserFormatter,
            useValue: new NgbDateMomentParserFormatter(),
        },
        CommonService,
        AssetStringPipe,
        ResultService,
        AccountingService,
        CommentService,
        TaskService,
        VisitService,
        SurveyService,
        CommunicationService,
        MfToastService,
        DocumentsService,
        TermsService,
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    ],
})
export class MainCalendarModule {}
